module.exports = __webpack_public_path__ + "img/en.ec54f79.png";